import { render } from "./view-contract-list.vue?vue&type=template&id=31e52fce"
import script from "./view-contract-list.vue?vue&type=script&setup=true&lang=js"
export * from "./view-contract-list.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/view-contract-list.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31e52fce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31e52fce', __exports__)) {
    api.reload('31e52fce', __exports__)
  }
  
  module.hot.accept("./view-contract-list.vue?vue&type=template&id=31e52fce", () => {
    api.rerender('31e52fce', render)
  })

}


export default __exports__